export default __webpack_public_path__ + "static/warrior_3-52c0ea111c69f50d359eab005eac10f0.jpg";